"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "@/src/hooks/usePathname";
import { upsertQuizResultId } from "./quizResultContextStorage";

const QUIZ_RESULT_ID_QUERY_KEY = "resultId";
const POLLING_TIMEOUT_MS = 5000;
const POLLING_INTERVAL_MS = 250;

const getResultIdFromSearch = (search: string): string | null => {
  const params = new URLSearchParams(search);
  const resultId = params.get(QUIZ_RESULT_ID_QUERY_KEY)?.trim();
  return resultId || null;
};

export const useGlobalQuizResultIdCapture = (): void => {
  const pathname = usePathname();
  const lastCapturedResultIdRef = useRef<string | null>(null);
  const pollingTimerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const clearPollingTimer = () => {
    if (!pollingTimerRef.current) {
      return;
    }
    clearInterval(pollingTimerRef.current);
    pollingTimerRef.current = null;
  };

  const captureResultId = (resultId: string, source: "route" | "delayed") => {
    if (lastCapturedResultIdRef.current === resultId) {
      return false;
    }
    lastCapturedResultIdRef.current = resultId;
    upsertQuizResultId(resultId);
    if (source === "delayed") {
    }
    return true;
  };

  useEffect(() => {
    const immediateResultId = getResultIdFromSearch(window.location.search);
    if (immediateResultId) {
      clearPollingTimer();
      captureResultId(immediateResultId, "route");
      return;
    }

    if (pollingTimerRef.current) {
      return;
    }

    const startedAt = Date.now();
    pollingTimerRef.current = setInterval(() => {
      const delayedResultId = getResultIdFromSearch(window.location.search);
      if (!delayedResultId) {
        if (Date.now() - startedAt >= POLLING_TIMEOUT_MS) {
          clearPollingTimer();
        }
        return;
      }
      const captured = captureResultId(delayedResultId, "delayed");
      if (captured) {
      }
      clearPollingTimer();
    }, POLLING_INTERVAL_MS);

    return () => {
      clearPollingTimer();
    };
  }, [pathname]);
};

/**
 * @deprecated Use useGlobalQuizResultIdCapture instead.
 */
